"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SQRT_MAX_UD60x18_DIV_BY_SCALE = exports.SQRT_MAX_SD59x18_DIV_BY_SCALE = exports.SQRT_MAX_UD60x18 = exports.SQRT_MAX_SD59x18 = exports.SCALE = exports.PI = exports.MIN_WHOLE_SD59x18 = exports.MIN_SD59x18 = exports.MAX_WHOLE_UD60x18 = exports.MAX_WHOLE_SD59x18 = exports.MAX_UD60x18 = exports.MAX_SD59x18 = exports.HALF_SCALE = exports.EPSILON_MAGNITUDE = exports.EPSILON = exports.E = void 0;

var evm_fp_1 = __importDefault(require("evm-fp"));

var numbers_1 = require("./numbers");

exports.E = "2.718281828459045235";
exports.EPSILON = evm_fp_1.default("1e-6");
exports.EPSILON_MAGNITUDE = numbers_1.bn("1e6");
exports.HALF_SCALE = "0.5";
exports.MAX_SD59x18 = "57896044618658097711785492504343953926634992332820282019728.792003956564819967";
exports.MAX_UD60x18 = "115792089237316195423570985008687907853269984665640564039457.584007913129639935";
exports.MAX_WHOLE_SD59x18 = "57896044618658097711785492504343953926634992332820282019728";
exports.MAX_WHOLE_UD60x18 = "115792089237316195423570985008687907853269984665640564039457";
exports.MIN_SD59x18 = "-57896044618658097711785492504343953926634992332820282019728.792003956564819968";
exports.MIN_WHOLE_SD59x18 = "-57896044618658097711785492504343953926634992332820282019728";
exports.PI = "3.141592653589793238";
exports.SCALE = "1";
exports.SQRT_MAX_SD59x18 = "240615969168004511545033772477.625056927114980741";
exports.SQRT_MAX_UD60x18 = "340282366920938463463374607431.768211455999999999";
exports.SQRT_MAX_SD59x18_DIV_BY_SCALE = "240615969168004511545.033772477625056927"; // biggest number whose square fits within int256

exports.SQRT_MAX_UD60x18_DIV_BY_SCALE = "340282366920938463463.374607431768211455"; // biggest number whose square fits within uint256